import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import { useFlightDetail } from "./useFlightDetail";
import { flightSections } from "./flightSections";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import { Passengers } from "./passenger/Passengers";
import { LinkedShowSimplePanel } from "document/linkshow/LinkedShowSimplePanel";
import { ButtonSecondary } from "components/Atoms/Button";

interface Props {
  flight: server.dto.Flight
  linkedShows: server.dto.LinkedShow[]
  passengers: server.dto.FlightPassenger[]

  onArtistChanged: (newArtist: server.dto.ArtistSmall) => void
  onDateChanged: (newDate: server.dto.AppointmentDateTime) => void
  onStatusChanged: () => void
  onAirportChanged: () => void

  refetchLinkedShows: () => Promise<void>
}

export const FlightDetailSection = (props: Props) => {
  const {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateFlightInstruction,
    refetchPassengers,
    isCreatingPassenger,
    setIsCreatingPassenger,
  } = useFlightDetail(
    props.flight,
    props.passengers,
    props.onArtistChanged,
    props.onDateChanged,
    props.onStatusChanged,
    props.onAirportChanged,
  );

  return <DetailSectionTemplate
    isInPageEditable={props.flight.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdate}
    sections={[
      ...flightSections(props.flight, state, getUpdateFlightInstruction),
      {
        type: "custom",
        key: "passengers",
        render: () => <SectionPanel.Panel
          key="passengers"
          id="passengers"
          button={props.flight.permissions.canModify ? <ButtonSecondary
            label={RESX.Buttons.btnNew}
            onClick={() => setIsCreatingPassenger(true)}
          /> : undefined}
          header={<SectionTemplateHeader>{RESX.Flight.Passengers}</SectionTemplateHeader>}
        >
          <Passengers
            isInPageEditable={props.flight.permissions.canModify}
            isCreating={isCreatingPassenger}
            setIsCreating={setIsCreatingPassenger}
            isInSidePanel={false}
            isPrivateJet={props.flight.flightType === "private"}
            flightId={props.flight.flightId}
            passengers={state.passengers}
            refetchPassengers={refetchPassengers}
          />
        </SectionPanel.Panel>
      }, {
        key: "linkedShows",
        type: "custom",
        render: () => <LinkedShowSimplePanel
          key="linkedShows"
          linkedShows={props.linkedShows}
          onChange={() => {
            props.refetchLinkedShows();
          }}
        />
      }
    ]}
  />
}